import { Box, TextField } from '@mui/material';
import { Controller } from 'react-hook-form';
import { EditFnaStepComponent } from '../types';
import { JSX } from 'react';

/**
 * Step with FNA details form
 */
const FnaDetailsStep: EditFnaStepComponent = ({ control }): JSX.Element => (
  <Box className="max-w-lg grid grid-cols-2 gap-8">
    <Controller
      name="description"
      control={control}
      render={({ field }): JSX.Element => (
        <TextField {...field} className="col-span-2" fullWidth label="FNA description" />
      )}
    />

    <Controller
      name="agentsBrokerName"
      control={control}
      render={({ field }): JSX.Element => (
        <TextField {...field} disabled fullWidth label="Broker name *" />
      )}
    />

    <Box />

    <Controller
      name="agentsBrokerCode"
      control={control}
      render={({ field }): JSX.Element => (
        <TextField {...field} disabled fullWidth label="Broker code *" />
      )}
    />

    <Controller
      name="agentsPracticeCode"
      control={control}
      render={({ field }): JSX.Element => (
        <TextField {...field} disabled fullWidth label="Broker house code *" />
      )}
    />
  </Box>
);

export default FnaDetailsStep;
